// extracted by mini-css-extract-plugin
export var changeIcon = "_5a-4";
export var container = "_5a-0";
export var divider = "_5a-7";
export var externalLinkIcon = "_5a-1";
export var green = "_5a-5";
export var helpCircleIcon = "_5a-3";
export var iconButton = "_5a-2";
export var red = "_5a-6";